import { ViewLoyaltyProduct } from '@src/api';
import { ALL_CITIES } from '@src/app/modules/search-cities';

import { LoyaltyStatus } from '../types';
import {
  LoyaltyProgramCategory,
  LoyaltyProgramProduct,
  LoyaltyProgramProductDiscountType,
  LoyaltyProgramProductImage,
  LoyaltyProgramProductPerson,
  LoyaltyProgramProductTerms,
} from '../../models';
import { LOYALTY_STATUSES_MAP } from '../constants';

export const convertToProduct = (item: ViewLoyaltyProduct): LoyaltyProgramProduct => {
  const coverImageId = item.photos?.find(item => item.isCover)?.id ?? item.photos?.[0]?.id;

  const images = [...(item.photos ?? [])].sort((a, b) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0));

  return {
    id: item.id,
    // TODO: нужно описание, как вычислять это поле
    isNew: false,
    isFavorite: item.isFavorite,
    status: LOYALTY_STATUSES_MAP[item.status as LoyaltyStatus],
    // @ts-ignore Валера не прописал данное поле в схеме
    createdBy: item['createdBy'],
    name: item.name,
    description: item.description,
    descriptionShort: item.descriptionShort,
    discountText: item.discountText ?? '',
    dateExpiration: item.dateExpiration ? new Date(item.dateExpiration) : undefined,
    sortOrder: item.sortOrder,
    categories: item.categories.map<LoyaltyProgramCategory>(category => ({
      id: category.id,
      name: category.name ?? '',
      parent: { id: category.categoryGroupId ?? '', name: category.categoryGroupName ?? '' },
    })),
    cities: !!item.cities?.length ? item.cities : [ALL_CITIES],
    images: images.map<LoyaltyProgramProductImage>(({ id, name, isCover }) => ({ id, file: name ?? '', isCover })),
    coverImageId,
    // TODO: пока не отображаем
    usedCount: undefined,
    contacts: {
      company: {
        id: item.organisationId ?? item.externalOrganisationId,
        parentOrganisationId: item.parentOrganisationId,
        name: item.organisationShortName ?? item.externalOrganisationName ?? '',
        logoId: item.organisationLogoId ?? item.externalOrganisationLogoId,
        info: item.organisationInfo,
      },
      mentor: item.contactUserId
        ? {
            id: item.contactUserId,
            // @ts-ignore поле не описано в схеме
            name: item.contactUserFIO ?? '',
          }
        : undefined,
      persons:
        item.contacts?.map<LoyaltyProgramProductPerson>(contact => ({
          ...contact,
          address: contact.address ?? '',
        })) ?? [],
    },
    terms:
      item.discountGroups?.map<LoyaltyProgramProductTerms>(group => {
        let discountType: LoyaltyProgramProductDiscountType = 'rate';

        if (group.discountAbsolute) {
          discountType = 'cash';
        } else if (group.discountText) {
          discountType = 'tag';
        }

        return {
          id: group.id,
          discountType,
          discount: group.discountRate ?? group.discountAbsolute ?? group.discountText ?? 0,
          description: group.discountOptions ?? '',
          promoCode: group.discountCode,
          showAsBarcode: group.isGenerateBarcode,
          showAsQRCode: group.generateQRCode,
          qrCodeImage: group.discountQRCodeFileId
            ? {
                id: group.discountQRCodeFileId,
                file: 'Изображение с кодом',
              }
            : undefined,
          groupName: group.groupName,
          isPermanentCode: group.isPermanentCode,
          isSingleCodeUse: group.isMultipleCodeUse === undefined ? false : !group.isMultipleCodeUse,
          maxCodeUsePerMonth: group.maxCodeUsePerMonth ?? 0,
          uniqueCodes: group.codesFileId
            ? {
                id: group.codesFileId,
                file: 'Файл с кодами',
              }
            : undefined,
        };
      }) ?? [],
    unionId: !!item.isAdvertisment ? item.parentOrganisationId : undefined,
    mapObjects: item.mapObjects ?? [],
  };
};
